<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17uwg5R/tc-custom/9781611520279.jpg?1723592050826" alt="This image is the cover for the book Crushed"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crushed
      </h1>
      <p class="bookDescription body article font2">
        <p>Once the star of his high school basketball team, Nathan Gayle has played the field for years. Now in his twenties, he's getting tired of one night stands and heated hook-ups with strangers; he wants something more. Was that asking too much?<br/><br/>Wes Roberts has had a fierce crush on Nathan since high school. A chance encounter at prom created a memory Wes still cherishes, one perfect moment in time. His current relationship with Roger pales in comparison, but he's been with the man for eight months now and they've settled into a routine that's not exactly comfortable.<br/><br/>When Wes and Nathan meet up again years later at a friend's party, the spark between them is rekindled. But there's Roger, who wrestles with anger and drinking problems. Roger, whom Wes is still dating. Though the choice between the two men seems obvious, breaking up with Roger may be easier said than done.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J.M. Snyder
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a4bd579